import { render, staticRenderFns } from "./IntegratedDispatching.vue?vue&type=template&id=ae534a0e&scoped=true"
import script from "./IntegratedDispatching.vue?vue&type=script&lang=js"
export * from "./IntegratedDispatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae534a0e",
  null
  
)

export default component.exports